export default "__VITE_ASSET__BlB782n0__"